import styled from 'styled-components';

import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { colors, transition } from 'theme/theme';

export const CloseButton = styled(Button)`
  aspect-ratio: 1;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  padding: 5px;
  color: ${colors.lightContentGrey};
  transition: all ${transition};

  &:hover {
    background-color: ${colors.selectionGrey};
    color: ${colors.darkContentGrey};
  }
`;
